

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
      align:'center'
    },
    {
      key: 'username',
      dataIndex: 'username',
      title: '投票人',
      width: 200,
      align:'center'
    },
    {
      key: 'museum1',
      dataIndex: 'museum1',
      title: '第一家博物馆',
      align:'center'
    },
    {
      key: 'votesum1',
      dataIndex: 'votesum1',
      title: '得票数',
      align:'center'
    },
    {
      key: 'museum2',
      dataIndex: 'museum2',
      title: '第二家博物馆',
      align:'center'
    },
    {
      key: 'votesum2',
      dataIndex: 'votesum2',
      title: '得票数',
      align:'center'
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
